import React from 'react'
import { useSelector } from 'react-redux'
import { FormattedMessage, injectIntl, IntlShape } from 'react-intl'
import BusinessActivity from 'components/BusinessActivity'
import FilterableList from 'components/FilterableList/FilterableList'
import { selectReviewsFilters } from 'store/business'
import messages from './messages'
import styles from './BusinessReviews.scss'

interface Source {
  key: string
  docCount: number
}

interface Review {
  [key: string]: any
}

interface BusinessReviewsProps {
  intl: IntlShape
  reviews?: Review[]
  onScroll?: () => void
  onFilter?: (filters: any) => void
  numberOfTotalItems?: number
  numberOfDocumentedItems?: number
  sources: Source[]
}

function BusinessReviews({
  intl,
  reviews = [],
  onScroll,
  onFilter,
  numberOfTotalItems = 0,
  numberOfDocumentedItems = 0,
  sources,
}: BusinessReviewsProps) {
  const filters = useSelector(selectReviewsFilters)

  const dropdownOptions = sources.map(({ key, docCount }) => ({
    value: key,
    label: (
      <FormattedMessage
        {...messages.option}
        values={{
          label: key === 'angies' ? "Angie's List" : key,
          count: docCount,
        }}
        tagName='span'
      />
    ),
  }))

  const dropdownSelections = sources
    .filter(({ key }) => filters.includes(key))
    .map(({ key, docCount }) => ({
      value: key,
      label: (
        <FormattedMessage
          {...messages.option}
          values={{
            label: key,
            count: docCount,
          }}
          tagName='span'
        />
      ),
    }))

  return (
    <FilterableList
      type='review'
      items={reviews}
      filterKey='reviewSource'
      filterOptions={dropdownOptions}
      filterSelections={dropdownSelections}
      onFilter={onFilter}
      onScroll={onScroll}
      numberOfTotalItems={numberOfTotalItems || 0}
      numberOfDocumentedItems={numberOfDocumentedItems || 0}
      renderItem={(review: Review) => (
        <div className={styles.review}>
          <BusinessActivity review={review} />
        </div>
      )}
    />
  )
}

export default injectIntl(BusinessReviews)
